import {v4 as uuidv4} from 'uuid';
import {getEnv} from '../../common/env/env';
import {ItemSingleDto} from '../../common/shared/api/gateway/ItemSingleDto.interface';
import {getDiscountRateText} from '../../common/shared/utils/getDiscountRateText';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {Bm, SaleState, Single, SlideType} from '../generated/types';
import {createAgeGrade, getAgeGradeVo} from './AgeGrade';
import {createAssetProperty} from './AssetProperty';
import {createBadgeType} from './BadgeType';
import {createOperatorProperty} from './OperatorProperty';
import {createSaleState} from './SaleState';
import {createSeries} from './Series';
import {createServiceProperty} from './ServiceProperty';
import {getSingleUpdateDateText} from './SingleListViewItem';
import {createSlideState} from './SlideState.enum';
import {createSlideType} from './SlideType.enum';

export function createSingle({
  age_grade,
  badge,
  is_free,
  state,
  thumbnail,
  title,
  product_id,
  free_change_dt,
  hidden,
  last_release_dt,
  page_count,
  size,
  slide_type,
  waitfree_blocked,
  service_property,
  operator_property,
  asset_property,
  series_property,
  start_sale_dt,
}: ItemSingleDto): Single {
  const slideType = createSlideType(slide_type);

  return {
    id: uuidv4(),
    seriesId: series_property?.series_id,
    productId: product_id,
    slideType,
    title,
    thumbnail: thumbnail.startsWith('http')
      ? thumbnail
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: thumbnail,
          resolution: 'th3',
        }),
    ageGrade: createAgeGrade(
      getAgeGradeVo({
        singleAgeGrade: age_grade,
        seriesAgeGrade: series_property?.age_grade,
      })
    ),
    isFree: is_free,
    remainText: getSingleUpdateDateText({
      bm: Bm.FreePreview, // remainText 가 비축분 한정이기 때문에 임의로 FreePreview 로 설정
      start_sale_dt,
      free_change_dt,
      singleIsFree: is_free,
      singleIsHidden: !!hidden,
    }),
    isHidden: hidden,
    isWaitfreeBlocked: waitfree_blocked,
    lastReleasedDate: last_release_dt,
    pageCount: page_count,
    size,
    state: createSlideState(state),
    saleState: state ? createSaleState(state) : SaleState.Unknown,
    badge: createBadgeType({nicolasBadgeTypeVo: {badge}}),
    series: series_property ? createSeries(series_property) : undefined,
    serviceProperty: service_property
      ? createServiceProperty(
          service_property,
          undefined,
          series_property?.series_id
        )
      : undefined,
    operatorProperty: operator_property
      ? createOperatorProperty(operator_property)
      : undefined,
    assetProperty: asset_property
      ? createAssetProperty(asset_property)
      : undefined,
    discountRate: operator_property?.cash_info?.discount_rate,
    discountRateText: getDiscountRateText({
      discountRate: operator_property?.cash_info?.discount_rate,
      setDiscountRate: operator_property?.cash_info?.set_discount_rate,
    }),
    isShortsDrama:
      operator_property?.is_short_drama && slideType === SlideType.TalkHumor,
  };
}
